export const LOGIN_FORM_STRINGS = {
  title: 'Log in',
  emailLabel: 'Email',
  emailRequired: 'Email is required',
  emailInvalid: 'Invalid email address',
  passwordLabel: 'Password',
  passwordRequired: 'Password is required',
  forgotPassword: 'Forgot password?',
  loginButton: 'Log in',
  loggingInButton: 'Logging in...',
} as const
